// extracted by mini-css-extract-plugin
export default {"playerContainer":"Navbar_playerContainer__AU-Co","red":"Navbar_red__BE6eG","yellow":"Navbar_yellow__YGnKs","blue":"Navbar_blue__BiFAH","green":"Navbar_green__5WZqO"};